import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface SearchEntityParams {
  query: string;
  result_count?: number;
  service: string;
  component: string;
}
export class SearchEntity extends BaseEntityClass {
  query: string;
  result_count?: number;
  service: string;
  component: string;
  constructor(params: SearchEntityParams) {
    super();
    this.type = "search";
    this.entity_version = 2;
    this.query = params.query;
    this.result_count = params.result_count;
    this.service = params.service;
    this.component = params.component;
  }
}
